import React from 'react'
import { useSearchParams } from 'react-router-dom'
import Games from './Games'
import Leaderboard from './LeaderBoard'
import Merchants from './Merchants'
import { capitalize } from 'Helper'
import Prizes from './Prizes'
import Participation from './Participation'
import { BsArrowLeft } from 'react-icons/bs'
import Colors from 'assets/colors'

const GamesParent = () => {

    const [queryParams, setQueryParams] = useSearchParams()
    const screen = queryParams?.get('screen')


    function RenderScreen() {
        switch (screen) {
            case 'leaderboard':
                return <Leaderboard />
            case 'merchants':
                return <Merchants />
            case 'prizes':
                return <Prizes />
            case 'participation':
                return <Participation />
            default:
                return <Games />
        }
    }

    return (
        <>
            {screen && <div className='bg-white absolute w-full p-4 mb-3 mt-[-16px] ml-[-40px] mr-[-100px]'>
                <div 
                className='flex items-center gap-3 cursor-pointer hover:bg-grey p-1 rounded w-fit '
                onClick={()=>{
                    setQueryParams(prev =>{
                        prev.delete('screen')
                        prev.delete('game')
                        return prev
                    })
                }}>
                    <BsArrowLeft fontWeight={700} color={Colors.primary} /> <span className='text-primary font-bold'> Back</span>
                </div>
            </div>

            }
            <div
                style={{ marginTop: screen ? '80px' : 0 }}
                className="  mt-24 mx-auto bg-white rounded-2xl shadow-sm p-4">


                <p className="text-2xl font-bold text-[#4F4F4F] w-full text-left mb-7">{capitalize(screen || 'games')}</p>

                <RenderScreen />
            </div>
        </>
    )

}

export default GamesParent